import { getResults } from './SearchManagerMockData';
import USSRequestBody from './USSRequestBody';
export default class MockSearch implements Searchable {
	mockSearchResults: SearchResult;
	name: string;

	constructor(params: Record<string, any>) {
		switch (params.mockType) {
			case 'USS':
				this.name = 'Mock USS';
				this.mockSearchResults = getResults();
				break;

			case 'LocalFiles':
				this.name = 'Mock LocalFiles';
				this.mockSearchResults = getResults();
				break;

			case 'Library':
				this.name = 'Mock Library';
				this.mockSearchResults = getResults();
				break;
		}
	}

	search(query: SearchablesQuery, startIndex: StartIndexType, limit: number): Promise<SearchResult> {
		return new Promise((resolve) => {
			const startTime = Date.now();
			// search mockResults to match query
			const queryResults: Array<ResultItem> = this.mockSearchResults.resultItems.filter((result) => {
				let match = result.attributes.name.includes(query.query);

				if (query.filter.dateModified) {
					const dateRange = USSRequestBody.processSelectedModifiedDateFilter(query.filter);
					match =
						match &&
						dateRange &&
						result.attributes.modificationDate >= dateRange.min &&
						result.attributes.modificationDate <= dateRange.max;
				}

				return match;
			});
			// return value defined here
			const searchResult: SearchResult = {
				resultItems: [],
				serverResult: {
					url: 'mock',
					message: '',
					requestId: '0',
					status: 200,
					duration: 0,
				},
				totalResults: queryResults.length,
				duration: 0,
			};
			let start = 0;
			let end = 0;

			// cut results down to startIndex and limit
			if (typeof startIndex === 'number') {
				start = startIndex;
				end = startIndex + limit;
			}

			const slicedResults: Array<ResultItem> = queryResults.slice(start, end);
			// sort results
			searchResult.resultItems = slicedResults.sort((el1, el2) => {
				let order = 0;

				switch (query.sort.sortBy) {
					case 'Name':
						if (query.sort.sortOrder === 'Ascending') {
							order = el1.attributes.name.localeCompare(el2.attributes.name, undefined, {
								numeric: true,
							});
						} else {
							order = el2.attributes.name.localeCompare(el1.attributes.name, undefined, {
								numeric: true,
							});
						}

						break;

					case 'ModificationDate':
						if (query.sort.sortOrder === 'Ascending') {
							if (el1.attributes.modificationDate < el2.attributes.modificationDate) {
								order = -1;
							}

							if (el1.attributes.modificationDate > el2.attributes.modificationDate) {
								order = 1;
							}
						} else {
							if (el2.attributes.modificationDate < el1.attributes.modificationDate) {
								order = -1;
							}

							if (el2.attributes.modificationDate > el1.attributes.modificationDate) {
								order = 1;
							}
						}

						break;

					case 'Size':
						if (query.sort.sortOrder === 'Ascending') {
							if (el1.attributes.fileSize < el2.attributes.fileSize) {
								order = -1;
							}

							if (el1.attributes.fileSize > el2.attributes.fileSize) {
								order = 1;
							}
						} else {
							if (el2.attributes.fileSize < el1.attributes.fileSize) {
								order = -1;
							}

							if (el2.attributes.fileSize > el1.attributes.fileSize) {
								order = 1;
							}
						}

						break;
				}

				return order;
			});
			searchResult.duration = Date.now() - startTime;
			resolve(searchResult);
		});
	}
}
